import React from "react";

export default function AccessAlert({ tone = "info", children }) {
  if (!children) return null;
  return (
    <div className={`pa-alert is-${tone}`} role={tone === "error" ? "alert" : "status"}>
      <span aria-hidden="true">{tone === "error" ? "!" : tone === "success" ? "✓" : "i"}</span>
      <p>{children}</p>
    </div>
  );
}

